var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03053,
    y: 0.642831,
    width: 34.8148,
    height: 34.8148,
    rx: 5.55556,
    fill: "#45852E",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.03053,
    y: 0.642831,
    width: 34.8148,
    height: 34.8148,
    rx: 5.55556,
    stroke: "#45852E",
    strokeWidth: 0.740741
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.531 13.4202H21.2161V12.9572C21.2161 12.5889 21.0698 12.2356 20.8093 11.9752C20.5489 11.7147 20.1956 11.5684 19.8273 11.5684H17.0495C16.6811 11.5684 16.3279 11.7147 16.0674 11.9752C15.8069 12.2356 15.6606 12.5889 15.6606 12.9572V13.4202H13.3458C13.223 13.4202 13.1052 13.469 13.0184 13.5558C12.9316 13.6426 12.8828 13.7604 12.8828 13.8832C12.8828 14.006 12.9316 14.1237 13.0184 14.2105C13.1052 14.2974 13.223 14.3461 13.3458 14.3461H13.8087V22.6795C13.8087 22.925 13.9063 23.1606 14.0799 23.3342C14.2536 23.5078 14.4891 23.6054 14.7347 23.6054H22.1421C22.3876 23.6054 22.6232 23.5078 22.7968 23.3342C22.9704 23.1606 23.068 22.925 23.068 22.6795V14.3461H23.531C23.6537 14.3461 23.7715 14.2974 23.8583 14.2105C23.9451 14.1237 23.9939 14.006 23.9939 13.8832C23.9939 13.7604 23.9451 13.6426 23.8583 13.5558C23.7715 13.469 23.6537 13.4202 23.531 13.4202ZM16.5865 12.9572C16.5865 12.8345 16.6353 12.7167 16.7221 12.6299C16.8089 12.5431 16.9267 12.4943 17.0495 12.4943H19.8273C19.95 12.4943 20.0678 12.5431 20.1546 12.6299C20.2414 12.7167 20.2902 12.8345 20.2902 12.9572V13.4202H16.5865V12.9572ZM22.1421 22.6795H14.7347V14.3461H22.1421V22.6795ZM17.5124 16.661V20.3647C17.5124 20.4874 17.4637 20.6052 17.3768 20.692C17.29 20.7788 17.1723 20.8276 17.0495 20.8276C16.9267 20.8276 16.8089 20.7788 16.7221 20.692C16.6353 20.6052 16.5865 20.4874 16.5865 20.3647V16.661C16.5865 16.5382 16.6353 16.4204 16.7221 16.3336C16.8089 16.2468 16.9267 16.198 17.0495 16.198C17.1723 16.198 17.29 16.2468 17.3768 16.3336C17.4637 16.4204 17.5124 16.5382 17.5124 16.661ZM20.2902 16.661V20.3647C20.2902 20.4874 20.2414 20.6052 20.1546 20.692C20.0678 20.7788 19.95 20.8276 19.8273 20.8276C19.7045 20.8276 19.5867 20.7788 19.4999 20.692C19.4131 20.6052 19.3643 20.4874 19.3643 20.3647V16.661C19.3643 16.5382 19.4131 16.4204 19.4999 16.3336C19.5867 16.2468 19.7045 16.198 19.8273 16.198C19.95 16.198 20.0678 16.2468 20.1546 16.3336C20.2414 16.4204 20.2902 16.5382 20.2902 16.661Z",
    fill: "#45852E",
    stroke: "#45852E",
    strokeWidth: 0.37037
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/deleteButton.12fd8d04205c10c20a76c87d301526db.svg";
export { ForwardRef as ReactComponent };